module.exports = __webpack_public_path__ + "img/snntg.0290826c.png";